/* global window */
import { takeLatest, takeEvery, select, all, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import R from 'ramda';

import * as cnt from './constants';
import { apiSaga } from '../../../sagas';
import {
  assetLanding as apis,
  account as accountApis,
  contracting as contractingApis,
  admin as adminApis,
} from '../../../api';

function* getAssets() {
  // for old url
  const { senderId } = yield select(state => state.assetsLandingReducer);
  yield* apiSaga(cnt.GET_ASSETS, apis.getAssets, [senderId]);
}

function* downloadContractingDocs({ payload: { docId } }) {
  if (docId) {
    yield put({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        docId,
        collection: 'contract',
        isBulk: true,
        forAL: true,
      },
    });
    // if (downloadType === 'pdf') {
    //   apis.downloadRatesContract(docId, 'Contractor', false);
    // } else if (downloadType === 'xls_summarized') {
    //   yield apiSaga(cnt.GET_XLS, apis.downloadRatesContractXls, [docId, 'summarized']);
    // } else if (downloadType === 'xls_desummarized') {
    //   yield apiSaga(cnt.GET_XLS, apis.downloadRatesContractXls, [docId, 'desummarized']);
    // } else if (downloadType === 'pdfCondensed') {
    //   apis.downloadRatesContract(docId, 'Contractor', true);
    // }
  }
  // yield call(delay, 300);
  // yield* getAssets();
}
function openXls({ payload: { location } }) {
  window.open(location);
}

function* init({ payload }) {
  const hashToken = payload.hashToken || 'oldUrl';
  const oldUrlPayload = payload.hashToken ? null : payload;
  // Important, we use this to retrieve the logged in session
  // we want to do this before verify token (retrieving info in the token from the backend)
  // so that after VERIFY_TOKEN, we can handle reroute first
  yield apiSaga(cnt.GET_LOGGED_IN_SESSION, adminApis.getSessionInfo, []);
  yield apiSaga('VERIFY_TOKEN', apis.verifyToken, [hashToken, oldUrlPayload]);
}

function* handleTracking({ payload }) {
  const { email, viewAs, userId } = yield select(state => state.assetsLandingReducer);
  yield put({
    type: 'TRACK_EVENT',
    payload: {
      ga: {
        eventCategory: 'assetLanding',
        eventAction: payload.eventAction || `click ${payload.type} - ${viewAs}`,
        eventLabel: `${email}-${userId}`,
      },
    },
  });
}

function* getRequest({ payload: { crId } }) {
  yield apiSaga(
    '[asset-landing]GET_REQUEST',
    contractingApis.getContractInfo,
    [{
      collection: 'contract',
      type: 'policyNotes',
      docId: crId,
      forAL: true,
    }],
  );
}

function* rerouteOrDownload() {
  const { loggedInSession = {}, contractId, contractIds, DL, shortid, hashToken, ...fromHash }
    = yield select(state => state.assetsLandingReducer);
  const { userId, companyType } = loggedInSession;
  const viewerLoggedInAndCorrectAcctType = userId && fromHash.userId && userId === fromHash.userId && companyType === fromHash.viewAs;
  // if viewer is the sender of the contract/request
  // OR if the receiver of the contract/request and is logged in to the correct account
  // route them to contract or contract list
  if (fromHash.viewerIsContractSender || viewerLoggedInAndCorrectAcctType) {
    if (contractId || (contractIds && contractIds.length === 1)) {
      window.location = `${window.location.protocol}//${
        window.location.host
      }/contracting/contract/${contractId || contractIds[0]}/details`;
    } else {
      window.location = `${window.location.protocol}//${
        window.location.host
      }/contracting/contract-list/recent?contractIds=${contractIds}`;
    }
  } else if (fromHash.viewAs === 'Contractor') {
    const downloadPayload = {
      collection: 'contract',
      isBulk: true,
      forAL: true,
    };
    if (contractId) {
      downloadPayload.docId = contractId;
    } else if (contractIds && contractIds.length === 1) {
      downloadPayload.docId = contractIds[0];
    } else if (contractIds && contractIds.length > 1) {
      downloadPayload.contractIds = contractIds;
    }
    yield put({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: downloadPayload,
    });
  } else if (fromHash.viewAs === 'Supplier' && (contractId || (contractIds && contractIds.length === 1))) {
    if (DL) {
      yield apiSaga(
        '[asset-landing]CHECK_DUMMY_ACCOUNT',
        apis.checkDummyAccount,
        [{ shortid, contractId: contractId || contractIds[0] }],
      );
    } else {
      yield put(push({
        pathname: '/assets-landing-request',
        query: yield select(state => state.routing.locationBeforeTransitions.query),
      }));
      yield getRequest({
        payload: {
          crId: contractId || contractIds[0],
        },
      });
    }
  }
}

function* onVerifyTokenSuccess({ payload }) {
  const hashToken = payload.hashToken;
  if (payload.autosignin && payload.userId) {
    yield* apiSaga(cnt.AUTO_LOGIN, accountApis.loginAsUser, [{
      hashToken,
      email: payload.realActorEmail,
      ...payload,
    }]);
    return;
  }
  const encryptedEmail = payload.encryptedEmail || 'newUrl';
  // this is to add hashtoken to req.headers for requests sending from AL page
  yield apiSaga(cnt.AUTH_BY_TOKEN, apis.authByToken, [hashToken, encryptedEmail]);
  sessionStorage.setItem('hashtoken', hashToken);
  sessionStorage.setItem('encryptedemail', encryptedEmail);
  if (window.location.pathname.indexOf('/assets-landing-signing') > -1) {
    yield getRequest({
      payload,
    });
  } else {
    yield rerouteOrDownload();
    yield all([
      getAssets(),
      handleTracking({
        payload: {
          eventAction: `page load - ${payload.userId ? 'Internal' : 'External'} ${payload.viewAs}`,
        },
      }),
    ]);
  }
}

function* updateContractStatus({ type, payload }) {
  yield* handleTracking({ payload: { type: payload.state } });
  yield* apiSaga(type, contractingApis.updateContractStatus, [
    {
      contractIds: payload.contractIds,
      state: payload.state,
    }
  ]);
}

function* login({ type, payload }) {
  yield* apiSaga(type, accountApis.login, [payload]);
}

function* routeToAppAfterLogin({ payload }) {
  localStorage.setItem('jwt', payload.user.jwt);
  const { hashToken, dialog, routeToUrl, jumpBackTo, userId } = yield select(state => state.assetsLandingReducer);
  if (dialog.associateEmail || dialog.routeToConsolidation) {
    window.location = `${window.location.protocol}//${
      window.location.host
    }/assets-consolidation/${hashToken}?associateEmail=${dialog.associateEmail}`;
  } else if (routeToUrl) {
    window.location = `${routeToUrl}${routeToUrl.indexOf('?') > -1 ? '&' : '?'}jumpBackTo=${
      jumpBackTo
    }&magicLinkHashToken=${hashToken}`;
  } else {
    window.location = `${window.location.protocol}//${
      window.location.host
    }/contracting/contract-list/recent`;
  }
}

function* signUp() {
  const signup = yield select(state => state.contractingSignUp.toJS());
  yield* apiSaga(cnt.SIGN_UP, accountApis.shellSignUp, [signup]);
}

function* autoLogin() {
  const { hashToken } = yield select(state => state.assetsLandingReducer);
  const { userId, email, companyType } = yield select(state =>
    R.path(['assetsLandingReducer', 'dialog', 'newUserInfo'], state),
  );
  yield* apiSaga(cnt.AUTO_LOGIN, accountApis.loginAsUser, [{ userId, email, companyType, hashToken }]);
}

function* scheduleDemo() {
  window.open('https://app.hubspot.com/meetings/andrew157');
  const { email, viewAs, userId } = yield select(state => state.assetsLandingReducer);
  yield put({
    type: 'TRACK_EVENT',
    payload: {
      ga: {
        eventCategory: 'assetLanding',
        eventAction: `scheduleDemo - ${viewAs}`,
        eventLabel: `${email}-${userId}`,
      },
    },
  });
}

function* requestEzLoad({ afterSignUp }) {
  const {
    dialog: { files, allRequests, newUserInfo },
    companyId,
    email: thisEmail,
  } = yield select(state => state.assetsLandingReducer);
  const supplierId = afterSignUp ? newUserInfo.companyId : companyId;
  const email = afterSignUp ? newUserInfo.email : thisEmail;
  const requests = allRequests.filter(obj => obj.checked);
  yield* apiSaga(cnt.REQUEST_EZ_LOAD, apis.ezLoadRequest, [{ supplierId, files, requests, email }]);
}

function* handleAfterSignup() {
  const { type: dialogType, newUserInfo } = yield select(state => state.assetsLandingReducer.dialog);
  if (dialogType === 'dl-wizard') yield* requestEzLoad({ afterSignUp: true });
  else if (newUserInfo.email.indexOf('dl+') > -1) {
    window.location = `${window.location.protocol}//${window.location.host}/admin/company-details/${newUserInfo.companyId}`;
  }
  // const { preconfirmed } = yield select(state => state.contractingSignUp.toJS());
  // const { hashToken, dialog: { alreadyLoggedIn } } = yield select(state => state.assetsLandingReducer);
  // if (alreadyLoggedIn && preconfirmed && payload.newCompany) {
  //   // show log out warning
  //   yield put({ type: cnt.UPDATE_PROPS_DIALOG, payload: {
  //       displayMsg: '',
  //       showwarning: true,
  //     } });
  // } else if (preconfirmed && payload.newCompany) {
  //   yield* autoLogin();
  //   yield call(delay, 100);
  //   window.location = `${window.location.protocol}//${window.location.host}/contracting/contract-list/recent`;
  // }
}

function* sendExternalRates({ type, payload }) {
  const { subject, message } = payload;
  const {
    dialog: { files, allRequests },
    email: fromEmail,
    userId,
    companyId,
  } = yield select(state => state.assetsLandingReducer);
  const requests = allRequests.filter(obj => obj.checked);
  yield* apiSaga(type, apis.sendExternalRates, [
    { subject, message, files, requests, fromEmail, userId, supplierId: companyId },
  ]);
}

function* downloadAll(what) {
  const {
    rates,
  } = yield select(state => state.assetsLandingReducer);
  yield put({
    type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
    payload: {
      contractIds: rates
        .filter(obj => {
          if (what === 'all') return true;
          if (what === 'current') return obj.endDate >= new Date().toISOString();
          return obj.endDate < new Date().toISOString();
        })
        .map(obj => obj._id),
      collection: 'contract',
      isBulk: true,
      forAL: true,
    },
  });
}
function* sendExternalRatesForOneRequest({ payload }) {
  const {
    email: fromEmail,
    userId,
  } = yield select(state => state.assetsLandingReducer);
  yield* apiSaga(cnt.SEND_RATES_FOR_ONE_REQUEST, apis.sendExternalRates, [{
    ...payload,
    fromEmail,
    userId,
  }]);
}

function* routeAfterCheckForDummy({ payload }) {
  window.location = payload.url;
}

function* handleAutoLoginError({ payload }) {
  window.alert(payload);
  window.location = `${window.location.protocol}//${window.location.host}/${payload.indexOf('TC admin') > -1 ? 'admin-signin' : 'signin'}`;
}

function* doSignRateDocs({ type, payload }) {
  yield apiSaga(type, apis.signRateDocs, [payload]);
}

function* markDummyTemplateAsViewed({ type, payload }) {
  yield apiSaga(type, apis.markDummyTemplateAsViewed, [{
    ...payload,
    from: 'al-signing',
  }]);
}

export default [
  takeLatest(cnt.DOWNLOAD_RATES_CONTRACT, downloadContractingDocs),
  takeLatest(cnt.INIT, init),
  takeLatest(`VERIFY_TOKEN_SUCCESS`, onVerifyTokenSuccess),
  takeLatest(cnt.CHANGE_CONTRACT_STATUS, updateContractStatus),
  takeLatest(cnt.LOG_IN, login),
  takeLatest(`${cnt.LOG_IN}_SUCCESS`, routeToAppAfterLogin),
  takeLatest(cnt.SIGN_UP, signUp),
  takeLatest(`${cnt.SIGN_UP}_SUCCESS`, handleAfterSignup),
  takeLatest(cnt.AUTO_LOGIN, autoLogin),
  takeLatest(`${cnt.AUTO_LOGIN}_SUCCESS`, routeToAppAfterLogin),
  takeLatest(`${cnt.AUTO_LOGIN}_ERROR`, handleAutoLoginError),
  takeLatest(cnt.OPEN_DIALOG, handleTracking),
  takeLatest(cnt.SCHEDULE_DEMO, scheduleDemo),
  takeLatest(cnt.REQUEST_EZ_LOAD, requestEzLoad),
  takeLatest(cnt.SEND_RATES, sendExternalRates),
  takeLatest(cnt.SEND_RATES_FOR_ONE_REQUEST, sendExternalRatesForOneRequest),
  takeEvery(`${cnt.GET_XLS}_SUCCESS`, openXls),
  takeLatest(cnt.DOWNLOAD_ALL_CURRENT, function* download() {
    yield downloadAll('current');
  }),
  takeLatest(cnt.DOWNLOAD_ALL, function* download() {
    yield downloadAll('all');
  }),
  takeLatest(cnt.DOWNLOAD_ALL_OUTDATED, function* download() {
    yield downloadAll('outdated');
  }),
  takeLatest('[asset-landing]CHECK_DUMMY_ACCOUNT_SUCCESS', routeAfterCheckForDummy),
  takeLatest('[asset-landing]SIGN_RATE_DOCS', doSignRateDocs),
  takeLatest('[asset-landing] RELOAD_CONTRACT_REQUEST', getRequest),
  takeLatest('[asset-landing] MARK_DUMMY_TEMPLATE_AS_VIEWED', markDummyTemplateAsViewed),
];



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/__storeFiles__/sagas.js